// extracted by mini-css-extract-plugin
export default {"input":"CrrInput_input__wu0Jx"};